<div class="progress-bar">
    <div class="progress-bar-track">
        <div class="progress-bar-line" [style.width.%]="percent"></div>
    </div>
    <div class="progress-bar-label">
        {{label}}
    </div>
</div>